import { Paper, Typography } from "@mui/material";
import React from "react";

const PartnerCard = ({ title }) => {
   return (
      <Paper
         sx={{
            width: "240px", // Fixed card width
            borderRadius: "8px", // Slight border radius for rounded corners
            boxShadow: 2, // Subtle shadow for depth
            overflow: "hidden", // Hide any overflow (important for truncating)
            margin: "10px", // Add spacing between cards
            display: "flex", // Use flexbox for alignment
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
         }}
      >
         {/* Title Section */}
         <Typography
            sx={{
               fontWeight: "bold",
               fontSize: "16px",
               padding: "10px",
               whiteSpace: "nowrap", // Prevent wrapping
               overflow: "hidden", // Hide overflow
               textOverflow: "ellipsis", // Show ellipsis if text is too long
            }}
         >
            {title}
         </Typography>
      </Paper>
   );
};

export default PartnerCard;
